





























































import {defineComponent, ref,} from '@nuxtjs/composition-api';
import {clickOutside} from "~/node_modules/@storefront-ui/vue/src/utilities/directives";

export default defineComponent({
  name: 'Select',
  directives: {clickOutside},
  props: {
    options: {
      type: Array,
      require: true
    },
    attribute: {
      type: Object
    },
    selected: {
      type: [Object, String]
    },
    search: {
      type: Boolean,
      default: false
    },
    searchText: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: "This field is not correct.",
    },
    valid: {
      type: Boolean,
      default: true,
    },
    labelValue: {
      type: [String, Boolean],
      default: false,
    },
    id: {
      type: String,
      default: ''
    },
    labelKey: {
      type: String,
      default: 'label'
    },
    valueKey: {
      type: String,
      default: 'uid'
    },
    preselect: {
      type: Boolean,
      default: true
    },
    isExist: {
      type: [Function, Boolean],
      default: false
    },
    translateLabels: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      opened: false,
      optionsSearch: []
    }
  },
  watch: {
    selected() {
      if (Object.keys(this.selected).length && !this.preselect) {
        this.selectedValue[this.labelKey] = this.selected[this.labelKey];
        this.selectedValue[this.valueKey] = this.selected[this.valueKey];
      }
    }
  },
  setup(props) {
    const selectedValue = ref(props.selected);

    if (!selectedValue.value) {
      selectedValue.value = props.options[0];
    }

    if (props.preselect && !selectedValue.value.hasOwnProperty(props.labelKey) && !selectedValue.value.hasOwnProperty(props.valueKey)) {
      //@ts-ignore
      selectedValue.value = props.options.filter((option) => option[props.valueKey] === props.selected)[0];
    }

    return {
      selectedValue
    }
  },
  methods: {
    searchItems($event) {
      let value = $event.target.value;

      if (!value) this.optionsSearch = [];

      value = value.toLowerCase();

      this.optionsSearch = this.options.filter((element) => {
        return (
          (element[this.labelKey] && element[this.labelKey].toLowerCase().indexOf(value) > -1) ||
          (element[this.valueKey] && element[this.valueKey].toLowerCase().indexOf(value) > -1)||
          value.indexOf(element[this.labelKey]) > -1 ||
          value.indexOf(element[this.valueKey]) > -1
        )
      })
    },
    setSelected(val) {
      this.selectedValue = val;
      this.opened = false;

      this.$emit('selectAction', val);
    },
    setSelectedSelect($event) {
      const val = $event.target.value;
      this.selectedValue[this.labelKey] = this.options.find((option) => option[this.valueKey] === val)[this.labelKey];
      this.selectedValue[this.valueKey] = val;

      this.$emit('selectAction', val);
    },
    closeSelect() {
      this.opened = false;
    },
    isExisting(val) {
      if (typeof this.isExist === "function") {
        //@ts-ignore
        return this.isExist(this.attribute, val);
      }

      return true;
    },
    clickOutsideEvent($event) {
      if ($event?.target?.className && $event?.target?.className?.indexOf('selected-item') > -1 || $event?.type === 'touchstart') return;
      this.opened = false;
    }
  }
});
